// imports react
import React, { useEffect, useState } from 'react';

//imports libraries
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

//imports components
import styles from "../styles/questionary.module.css";

import { urlAPI_Current } from '../config';
import { HelpCircleIcon } from 'lucide-react';

export function Questions(props) {
    const navigateTo = useNavigate();

    const [opcaoA, setOpcaoA] = useState(0);
    const [opcaoB, setOpcaoB] = useState(0);
    const [opcaoC, setOpcaoC] = useState(0);
    const [opcaoD, setOpcaoD] = useState(0);
    const [answered, setAnswered] = useState(false);

    async function handleSubmit(event) {
        event.preventDefault();
        console.log(opcaoA);
       
        if (opcaoA + opcaoB + opcaoC + opcaoD == 10) {
            try {
                let response = "";

                if(answered){ // já respondeu, atualizar
                    response = await axios.post(`${urlAPI_Current}/updateQuestionsNotes`, {
                        idQuestion: props.idQuestion,
                        noteA: opcaoA,
                        noteB: opcaoB,
                        noteC: opcaoC,
                        noteD: opcaoD
                    } , {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                    });
                } else { // não respondeu, inserir
                    response = await axios.post(`${urlAPI_Current}/addQuestionsNotes`, {
                        idQuestion: props.idQuestion,
                        noteA: opcaoA,
                        noteB: opcaoB,
                        noteC: opcaoC,
                        noteD: opcaoD
                    } , {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                    });
                }
                if(response.data.success == true) {
                    await axios.post(`${urlAPI_Current}/addProfileSkills`, {
                        idQuestion: props.idQuestion,
                        noteA: opcaoA,
                        noteB: opcaoB,
                        noteC: opcaoC,
                        noteD: opcaoD
                    }, {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                    });

                    props.onAdvance();
                    setAnswered(false);
                    setOpcaoA(0);
                    setOpcaoB(0);
                    setOpcaoC(0);
                    setOpcaoD(0);

                    if(props.idQuestion == 12){
                        toast.success('Questionário Concluido com sucesso!');
                        await axios.post(`${urlAPI_Current}/addTypeProfiles`, {
                            email: localStorage.getItem('email'),
                            name: localStorage.getItem('name')
                        }, {
                            headers: {
                              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                            }
                        });
                        navigateTo('/resultQuestionary');
                    } 
                }
            } catch (error) {
                console.log("Erro ao salvar nota")
            }
        } else {
            toast.error('Tem que ser distribuidos exatamente 10 pontos!');
        }
    }

    async function getNotes(){
        const responseNotes = await axios.post(
            `${urlAPI_Current}/getNotesQuestion`,
            {
              idQuestion: props.idQuestion
            },  {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
            }
        );

        console.log(responseNotes.data)

        if(responseNotes.data.answered){
            setOpcaoA(responseNotes.data.notes[0].notaA)
            setOpcaoB(responseNotes.data.notes[0].notaB)
            setOpcaoC(responseNotes.data.notes[0].notaC)
            setOpcaoD(responseNotes.data.notes[0].notaD)
            setAnswered(true);
        } 
    }

    function showHelpMessage(){
        toast.info('Clique no campo de nota e arraste até a pontuação desejada.');
    }

    async function handleReturn(){
        console.log("voltando")
        props.onReturn();
    }

    useEffect(() => {
        // zera antes de buscar
        setOpcaoA(0);
        setOpcaoB(0);
        setOpcaoC(0);
        setOpcaoD(0);
        setAnswered(false);

        getNotes();
    }, [props.idQuestion])

    return (
        <div>
            <form className={styles.formsQuestionary} onSubmit={handleSubmit}>
                <h4>{props.subtitle}</h4> <br />
                <label>A - {props.opcaoA}</label> <br />
                <input
                    type="range"
                    value={opcaoA}
                    onChange={(e) => setOpcaoA(parseInt(e.target.value, 10))}
                    min="0"
                    max="10"
                    step="1"
                /> <span>Pontos: {opcaoA}</span> <br />
                <br />
                <label>B - {props.opcaoB}</label> <br />
                <input
                    type="range"
                    value={opcaoB}
                    onChange={(e) => setOpcaoB(parseInt(e.target.value, 10))}
                    min="0"
                    max="10"
                    step="1"
                /> <span>Pontos: {opcaoB}</span> <br />
                <br />
                <label>C - {props.opcaoC}</label> <br />
                <input
                    type="range"
                    value={opcaoC}
                    onChange={(e) => setOpcaoC(parseInt(e.target.value, 10))}
                    min="0"
                    max="10"
                    step="1"
                /> <span>Pontos: {opcaoC}</span> <br />
                <br />
                <label>D - {props.opcaoD}</label> <br />
                <input
                    type="range"
                    value={opcaoD}
                    onChange={(e) => setOpcaoD(parseInt(e.target.value, 10))}
                    min="0"
                    max="10"
                    step="1"
                /> <span>Pontos: {opcaoD}</span><br />
                <br />
                <div className={styles.divBaseboard}>
                    <div className={styles.divReturn}>
                        {props.idQuestion != 1 ? (<p className={styles.returnTrue} onClick={() => handleReturn()}>← Voltar</p>) : (null)}
                    </div>
                    <div className={styles.points}>
                        <strong>Pontos distribuidos: </strong>
                        {opcaoA + opcaoB + opcaoC + opcaoD < 10 || opcaoA + opcaoB + opcaoC + opcaoD > 10 ? (
                            <p className={styles.pointsIncorrect}>{opcaoA + opcaoB + opcaoC + opcaoD}/10</p>
                        ) : (
                            <p className={styles.pointsCorrect}>{opcaoA + opcaoB + opcaoC + opcaoD}/10</p>
                        )}
                    </div>
                    <div className={styles.continue}>
                        <strong onClick={() => showHelpMessage()} className={styles.help}><HelpCircleIcon height= "30px" width="30px" /> </strong>
                        {opcaoA + opcaoB + opcaoC + opcaoD == 10 ? (
                            <button className={styles.continueTrue} type="submit">→ Continuar</button>
                        ) : (
                            <button className={styles.continueFalse}>→ Continuar</button>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}
